import React from 'react';

import { H1Styled } from './H1.style';

export const H1 = ({ children, ...props }: { children: any }) => {
  return <H1Styled {...props}>{children}</H1Styled>;
};
